import { styled } from '@mui/material';

import { useI18n } from '@app-velocity/i18n';

import { FigmaPluginDownloadButton } from '../FigmaPluginDownloadButton';

const HomeInfo = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  gap: theme.spacing(6),
  margin: 'auto',
  width: '100%',
  minHeight: '50vh',
}));

const HomeHeader = styled('h1')({
  fontSize: 36,
  fontWeight: 800,
  margin: 0,
});

const HomeSubtitle = styled('p')({
  fontSize: 24,
  fontWeight: 500,
  margin: 0,
});

const HomeDescription = styled('p')({
  fontSize: 16,
  fontWeight: 300,
  margin: 0,
  whiteSpace: 'pre-wrap',
  color: 'var(--text-text-secondary-color)',
});

export const NoReports = () => {
  const { t } = useI18n();

  return (
    // <Container>
    <HomeInfo>
      <HomeHeader>{t('shared:welcome')}</HomeHeader>
      <HomeSubtitle>{t('shared:get_started_with_plugin')}</HomeSubtitle>
      <HomeDescription>{t('shared:get_started_description')}</HomeDescription>
      <FigmaPluginDownloadButton />
    </HomeInfo>
    // </Container>
  );
};
